import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../../partials/PageTitle";
import { BeatLoader } from "react-spinners";
import {
  resetCustomerPolicies,
  resetCustomerSinglePolicyDetailsView,
  viewCustomerPolicies,
} from "../../../../redux/slice/policy/policySlice";
import { BiArrowBack } from "react-icons/bi";

const PolicyInformation = ({ status }) => {
  const [attachPolicy, setAttachPolicy] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const { single_customer } = useSelector((state) => state?.customer);
  const { customer_policies, isSuccess, isLoading } = useSelector(
    (state) => state?.policy
  );

  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Applied Policies",
      link: "",
    },
    current: {
      title: "overview",
      link: null,
    },
  };

  useEffect(() => {
    setAttachPolicy(
      user_permissions?.some(
        (permission) => permission.name === "attach policy - individual"
      )
    );
  }, [user_permissions]);

  useEffect(() => {
    dispatch(resetCustomerPolicies());
    dispatch(viewCustomerPolicies({ customer_id: id }));
    dispatch(resetCustomerSinglePolicyDetailsView());
  }, []);

  if (!customer_policies) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Information' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* Table row */}

      <div className='row mb-3'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-body'>
              <div className=''>
                <div className='d-flex justify-content-end'>
                  <button
                    className='btn btn-sm btn-primary d-flex align-items-center mb-2 gap-1'
                    onClick={() => navigate(-1)}
                  >
                    <BiArrowBack size={14} />
                    <span>Back</span>
                  </button>
                </div>
                <h3>General Policy</h3>
                <div id='products-datatable_wrapper' className='no-footer'>
                  <div className='row'>
                    <div className='col-sm-12 table-responsive'>
                      <table
                        className={`table table-centered table-striped no-footer ${
                          customer_policies.policy_app_details?.length < 1 &&
                          "row"
                        }`}
                      >
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "147.8px" }}
                              aria-label='Email: activate to sort column ascending'
                            >
                              POLICY NO.
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "120.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              POLICY NAME
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "144.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              PREMIUM
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "144.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              STATUS
                            </th>
                            <th style={{ width: "105.8px" }}>ACTION</th>
                          </tr>
                        </thead>

                        {customer_policies.policy_app_details?.length < 1 ? (
                          <div className=''>
                            <h5 className='alert alert-info'>
                              No general policy attached yet.
                            </h5>
                          </div>
                        ) : (
                          <tbody>
                            {customer_policies?.policy_app_details &&
                              customer_policies?.policy_app_details?.map(
                                (data) => (
                                  <tr key={data.id}>
                                    <td className='text-dark'>
                                      {data.policyAppNumber}
                                    </td>

                                    <td className='table-user'>
                                      <a
                                        href='/'
                                        className='text-body fw-semibold'
                                      >
                                        {data.policyName}
                                      </a>
                                    </td>

                                    <td className='table-user'>
                                      <a
                                        href='/'
                                        className='text-body fw-semibold'
                                      >
                                        {data.totalPremium}
                                      </a>
                                    </td>
                                    <td>
                                      <span className='badge badge-success-lighten'>
                                        {data?.status === "2" && "Active"}
                                      </span>
                                      <span className='badge badge-warning-lighten'>
                                        {data?.status === "1" && "Pending"}
                                      </span>
                                      <span className='badge badge-danger-lighten'>
                                        {data?.status === "3" && "Matured"}
                                      </span>
                                    </td>
                                    <td className='text-body'>
                                      <Link
                                        to={`/admin/customer-policy-view`}
                                        state={{
                                          customerId: data?.customerId,
                                          policyAppNumber:
                                            data?.policyAppNumber,
                                        }}
                                      >
                                        <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                                      </Link>
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-body'>
              <div className=''>
                <h3>Savings Policy</h3>
                <div id='products-datatable_wrapper' className='no-footer'>
                  <div className='row'>
                    <div className='col-sm-12 table-responsive'>
                      <table
                        className={`table table-centered table-striped no-footer ${
                          customer_policies.savings_app_details?.length < 1 &&
                          "row"
                        }`}
                      >
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "147.8px" }}
                              aria-label='Email: activate to sort column ascending'
                            >
                              POLICY NO.
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "120.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              POLICY NAME
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "144.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              PREMIUM
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "144.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              STATUS
                            </th>
                            <th style={{ width: "105.8px" }}>ACTION</th>
                          </tr>
                        </thead>

                        {customer_policies.savings_app_details?.length < 1 ? (
                          <div className=''>
                            <h5 className='alert alert-info'>
                              No savings policy attached yet.
                            </h5>
                          </div>
                        ) : (
                          <tbody>
                            {customer_policies?.savings_app_details &&
                              customer_policies?.savings_app_details?.map(
                                (data) => (
                                  <tr key={data.id}>
                                    <td className='text-dark'>
                                      {data.policyAppNumber}
                                    </td>

                                    <td className='table-user'>
                                      <a
                                        href='/'
                                        className='text-body fw-semibold'
                                      >
                                        {data.policyName}
                                      </a>
                                    </td>

                                    <td className='table-user'>
                                      <a
                                        href='/'
                                        className='text-body fw-semibold'
                                      >
                                        {parseFloat(data.totalPremium).toLocaleString()}
                                      </a>
                                    </td>
                                    <td>
                                      <span className='badge badge-success-lighten'>
                                        {data?.status === "2" && "Active"}
                                      </span>
                                      <span className='badge badge-warning-lighten'>
                                        {data?.status === "1" && "Pending"}
                                      </span>
                                      <span className='badge badge-info-lighten'>
                                        {data?.status === "3" && "Matured"}
                                      </span>
                                      <span className='badge badge-danger-lighten'>
                                        {data?.status === "4" && "Terminated"}
                                      </span>
                                    </td>
                                    <td className='text-body'>
                                      <Link
                                        to={`/admin/customer-savings-policy-view`}
                                        state={{
                                          customerId: data?.customerId,
                                          policyAppNumber:
                                            data?.policyAppNumber,
                                        }}
                                      >
                                        <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                                      </Link>
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PolicyInformation;
